export enum FirestoreCollections {
  PlayHistory = 'play-history',
  ProgramHistory = 'program-history',
  Users = 'users',
  Downloads = 'download-history',
}
